export var DEPLOY_DATE = new Date('2026-07-22T14:04:41+0000');
